<template>
  <div class="lsr-container">
    <link href='https://fonts.googleapis.com/css?family=Teko' rel='stylesheet'>
    <span v-if="loading">
      <b-spinner label="Spinning"></b-spinner>
    </span>
    <span v-else>
      <div v-if="mode">
        <div v-for="(data,index) in filteredOutcomes" :key=index>
          <h1 v-if="data[0]==='t1'"> {{data[language[selectedLanguage]]}} </h1>
          <h2 v-if="data[0]==='t2'" :id="'id'+index.toString()"> {{data[language[selectedLanguage]]}} </h2>
          <h3 v-if="data[0]==='t3'"> {{data[language[selectedLanguage]]}} </h3>
          <h4 v-if="data[0]==='t4'"> {{data[language[selectedLanguage]]}} </h4>
          <h5 v-if="data[0]==='t5'"> {{data[language[selectedLanguage]]}} </h5>
          <!-- <p v-if="data[0].toLowerCase()==='p'"> {{data[language[selectedLanguage]]}} </p> -->
          <custom-p v-if="data[0].toLowerCase()==='p'" :text="data[language[selectedLanguage]]" :refFinal="refFinal" :references="references" />
          <table-lovely v-if="data[0]==='table'" :gid="data[1]" :url="url" :sheets="sheets" />
          <prisma-covid v-if="data[0]==='prisma'" :gid="data[1]" :url="url" :sheets="sheets"/>
          <list v-if="data[0]==='ul' || data[0]==='ol'" :lists="lists" :index="data[1]" :language="language[selectedLanguage]" />
          <img class="image" v-if="data[0]==='img'" :src="data[1]" />
          <iframe 
            v-if="data[0]==='isof'" 
            :src="'https://isof.epistemonikos.org/#/exportable_table/'+data[1]" 
            v-resize="{ log: false }"
            class="isof-table"
            frameborder="0"
          />
          <br v-if="data[0]===''">
        </div>
      </div>
      <div v-else>
        <p> {{data[0]}} </p>
      </div>
    </span>
  </div>
</template>

<script>
// @ is an alias to /src
import SectionFooter from '@/components/SectionFooter.vue'
import Reference from '@/components/Reference.vue'
import RightSidebar from '@/components/RightSidebar.vue'
import TableLove from '@/components/Table.vue'
import Prisma from '@/components/Prisma.vue'
import PrismaCovid from '@/components/PrismaCovid2.vue'
import Lists from '@/components/Lists.vue'
import axios from 'axios'
import customPElement from '@/components/customPElement.vue'

export default {
  name: 'Tab',
  data() {
    return {
      csvData : [],
      leftMenuContent: [],
      leftMenuId: [],
      loading: true,
      lists: [],
      lists_counter: 0,
      references: [],
      refFinal: [],
      allRef: [],
      ignoreSectionName: true
    }
  },
  props: ['gid', 'url', 'language', 'selectedLanguage', 'objKey', 'scrollId', 'sectionName', 'sheets'],
  components: {
    'reference': Reference,
    'section-footer': SectionFooter,
    'sidebar': RightSidebar,
    'table-lovely': TableLove,
    'prisma': Prisma,
    'prisma-covid': PrismaCovid,
    'list': Lists,
    'custom-p': customPElement
  },
  computed: {
    mode: function(){
      if (this.csvData.length){
        return this.csvData[0].length > 1
      } else {
        return false
      }
    },
    filteredOutcomes: function () {
      let filtered = []
      let filterElement = false
      for (const element of this.csvData) {
        if (['t2'].includes(element[0])) {
          if (this.$route.params.sectionName.trim().toLowerCase() == element[this.language['EN']].trim().toLowerCase()) {
            filterElement = true
          } else {
            if (['t2', 't1'].includes(element[0]) && filterElement) {
              filterElement = false
              break
            }
          }
        }
        if (filterElement) {
          if (this.ignoreSectionName) {
            this.ignoreSectionName = false
          } else {
          filtered.push(element)
        }
        } 
      }
      return filtered
    }
  },
  mounted: function(){
    if (this.gid) {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('gapi.access_token')}` }
      }
      axios.get(
      'https://sheets.googleapis.com/v4/spreadsheets/'+ this.url, config
    )
    .then((res2)=>{
      let vm = this
      let createList = false
      let type = ""
      let count = 0
      const sheetNumber = this.getSheetNumberByGid(res2.data.sheets, this.gid)
      const title = res2.data.sheets[sheetNumber].properties.title
      axios.get(
        'https://sheets.googleapis.com/v4/spreadsheets/'+ this.url+ '/values/'+ title+'!A1:AZ9999', config
        ).then ( (res) => {
         if (!res.data.hasOwnProperty('values')) {
           vm.loading = false
           vm.csvData = [['t1','']]
           return
         }
      for (let i = 0 ; i < res.data.values.length; i++) {
            if (res.data.values
              && res.data.values[i] != "") {
              const record = res.data.values[i]
              if (record[0] === 't2') {
                vm.leftMenuContent.push(record)
                vm.leftMenuId.push('id'+count.toString())
              }
              if (createList && (record[0]=== type)) {
                vm.lists[vm.lists_counter].elements.push(record)
              }
              else if (createList && !(record[0]===type)) {
                vm.lists_counter+=1
                if ((record[0]==='ul' || record[0]==='ol')) {
                  type = record[0]
                  vm.csvData.push([record[0], vm.lists_counter])
                  vm.lists.push({type: record[0], elements: []})
                  vm.lists[vm.lists_counter].elements.push(record)
                  count+=1
                } else {
                  createList = false
                  vm.csvData.push(record)
                  count+=1
                }
              } 
              else if (!createList && (record[0]==='ul' || record[0]==='ol')) {
                type = record[0]
                createList = true
                vm.csvData.push([record[0], vm.lists_counter])
                vm.lists.push({type: record[0], elements: []})
                vm.lists[vm.lists_counter].elements.push(record)
                count+=1
              } else {
                if(record[1]){
                    let ref = record[1].match(/\[[\da-fA-F]{40}\]/gim)
                    if (ref) {
                      vm.references = [...new Set([...vm.references, ...ref])]
                    }
                  }
                  vm.csvData.push(record)
                  count+=1
              }
            }
      }
      vm.loading=false
      this.getCitations()
      vm.$emit('leftMenu', vm.leftMenuContent, vm.leftMenuId, vm.objKey)
    })})
    .catch((error)=>{
      console.log(error)
      this.loading = false;
      this.csvData = [['t1','Error'],['t3',error.data]]
    })
    }
    else{
      this.loading = false
    }
  },
  methods : {
    getSheetNumberByGid: function(data, gid) {
      for (let i = 0; i < data.length; i++) {
        if (gid == data[i].properties.sheetId) {
          return i
        }
      }
    },
     getCitations: function() {
      const clean_references = this.references.map( (ref) => {return ref.replace(/[\[\]']+/g, '')})
      if (clean_references.length == 0){
        return
      }
      const payload = {"responseType":"blob","references_ids": clean_references}
      const authToken = 'ad0cc24478434b0ca69e85b487934264'
      const config = {
        headers: {
          Authorization: `Token session="${authToken}"`
        }
      }
      const url = 'https://api.iloveevidence.com/v2.1/references/get-from-ids?filetype=citation_json'
      axios.post(url,payload, config)
      .then((res) => {
        this.refFinal = res.data.references
        this.allRef = this.references.map((reference) => {
          const auxRefFinal = this.refFinal.map( (ref) => { return ref.id})
          let cleanRef = reference.replace(/[\[\]']+/g, '')
          let index = auxRefFinal.indexOf(cleanRef)
          if (index > -1){
            return {
              id: cleanRef,
              citation: this.refFinal[index].citation
            }
          }
          else {
            return {
              id: cleanRef,
              citation: ''
            }
          }
        })
      })
      }, 
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/styles/variables.scss";
  .lsr-container {
    font-size: 14px;
    h1 {
      font-size: 43px;
      font-family: "Teko",sans-serif;
    }
    h2 {
      font-size: 30px;
      font-family: "Teko",sans-serif;
    }
    h3 {
      font-size: 28px;
      font-weight: bold;
      font-family: "Teko",sans-serif;
    }
    h4 {
      font-size: 28px;
      font-family: "Teko",sans-serif;
    }
    h5 {
      font-size: 25px;
      font-family: "Teko",sans-serif;
    }

    .header {
      margin-bottom: 2em;
      h1 {
        font-weight: bold;
        margin-top: 0.3em;
        margin-bottom: 1em;
      }
      .publication-type {
        font-weight: bold;
        font-size: 0.9em;
      }
      .authors, .dates {

      }
    }

    .tab_content {
      .languages {
        margin-bottom: 2em;
      }
      h1:not(:first-child) {
        margin-top: 1.8em;
      }
      h2 {
        font-weight: bold;
        &:not(:first-child) {
          margin-top: 1.4em;
        }
      }
      h3 {
        font-style: italic;
        &:not(:first-child) {
          margin-top: 1.2em;
        }
      }
      ul.arrow {
        margin-inline-start: 1.5em;
        // li:before {
        //   font-family: 'FontAwesome';
        //   content: '\f061'
        // }
      }
    }

    .image {
      max-width: 100%;
    }
    .isof-table {
      width: 1200px;
    }
    .isof {
      min-width: 801px;
      min-height: 600px;
    }
  }
</style>
